var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoWithoutText(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 69,
    viewBox: "0 0 58 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6253 40.8071L6.3727e-05 23.1818L1.15039 22.0315L18.7757 39.6568L17.6253 40.8071Z",
    fill: "#219653"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.2838 1.15018L17.6269 40.8071L16.4766 39.6567L56.1334 -0.000142007L57.2838 1.15018Z",
    fill: "#219653"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6253 46.3152L6.3727e-05 28.6899L1.15039 27.5396L18.7757 45.1648L17.6253 46.3152Z",
    fill: "#219653"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.2838 6.65824L17.6269 46.3151L16.4766 45.1648L56.1334 5.50791L57.2838 6.65824Z",
    fill: "#219653"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6253 51.823L6.3727e-05 34.1977L1.15039 33.0474L18.7757 50.6726L17.6253 51.823Z",
    fill: "#219653"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.2838 12.1661L17.6269 51.8229L16.4766 50.6726L56.1334 11.0157L57.2838 12.1661Z",
    fill: "#219653"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6253 57.331L6.3727e-05 39.7057L1.15039 38.5554L18.7757 56.1807L17.6253 57.331Z",
    fill: "#219653"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.2838 17.6741L17.6269 57.331L16.4766 56.1807L56.1334 16.5238L57.2838 17.6741Z",
    fill: "#219653"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6253 62.8388L6.3727e-05 45.2136L1.15039 44.0632L18.7757 61.6885L17.6253 62.8388Z",
    fill: "#219653"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.2838 23.1819L17.6269 62.8388L16.4766 61.6885L56.1334 22.0316L57.2838 23.1819Z",
    fill: "#219653"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6253 68.2256L6.3727e-05 50.6003L1.15039 49.45L18.7757 67.0752L17.6253 68.2256Z",
    fill: "#219653"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.2838 28.5686L17.6269 68.2255L16.4766 67.0752L56.1334 27.4183L57.2838 28.5686Z",
    fill: "#219653"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWithoutText);
export default __webpack_public_path__ + "static/media/logoWithoutText.08663c7dbb90e34d98a36423f12df278.svg";
export { ForwardRef as ReactComponent };